"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _urlHelper = require("./url-helper");

var _screenHelper = require("./screen-helper");

var CMD_ASPECT_RESIZE = 'as';
var CMD_RESIZE = 's';
var CMD_CROP = 'c';
var IMPRESSLY_BASE_URL = 'impress.ly';
var MYWEBSITEBUILDER_BASE_URL = 'images.builderservices.io';
var UNSPLASH_DOMAIN = 'images.unsplash.com'; // Refactor Remove the Impressly Image proxy

var ImageProxyHelper =
/*#__PURE__*/
function () {
  function ImageProxyHelper(src, cdnType) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ImageProxyHelper);

    this._proxyHash = function (value) {
      if (typeof value !== 'string' || value === '') {
        return 0;
      }

      value = value.toLowerCase();
      var c = 0;

      for (var i = 0; i < value.length; i++) {
        c ^= value.charCodeAt(i);
      }

      return c % 10;
    };

    this.crop = function (width, height, cropX, cropY) {
      _this.modifiers.push(CMD_CROP + '/' + Math.round(width) + '/' + Math.round(height) + '/' + Math.round(cropX) + '/' + Math.round(cropY));

      return _this;
    };

    this.crop = function (crop, originalSize) {
      if (_this.useUnsplash) {
        if (originalSize) {
          // crop at unsplash server
          var rect = _this.calcCropRect(crop.rect, originalSize).join(',');

          _this.src = _this.modifiyUnsplashUrl(_this.src, null, null, rect);
          return _this;
        } else {
          // we don't know the original size of the image so first load the cropped (down sized) version of the image and then crop at our own server
          if (crop.imageSize.width && crop.imageSize.height) {
            _this.src = _this.modifiyUnsplashUrl(_this.src, crop.imageSize.width, crop.imageSize.height);
          }

          _this.useUnsplash = false; // let crop be done by our own server
        }
      }

      if (originalSize || crop.imageSize && crop.imageSize.width && crop.imageSize.height) {
        var _rect = _this.calcCropRect(crop.rect, originalSize || crop.imageSize);

        _this.modifiers.push("".concat(CMD_CROP, "/").concat(_rect[2], "/").concat(_rect[3], "/").concat(_rect[0], "/").concat(_rect[1]));
      }

      return _this;
    };

    this.resizeToWidth = function (width) {
      if (_this.useUnsplash) {
        _this.src = _this.modifiyUnsplashUrl(_this.src, width);
      } else {
        _this.modifiers.push("".concat(CMD_ASPECT_RESIZE, "/").concat(width, "x").concat(width, "/0"));
      }
    };

    this.resize = function () {
      var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _screenHelper.getResolution)();
      var preserveAspect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      _this.modifiers.push("".concat(preserveAspect ? CMD_ASPECT_RESIZE : CMD_RESIZE, "/").concat(size, "/0"));

      return _this;
    };

    this.result = function () {
      if (_this.useUnsplash) {
        if (_this.cdnType === 'cloudflareHosted') {
          // let cloudfare route to unsplash
          return "/s/cdn/?".concat(encodeURIComponent(_this.src));
        }

        if (_this.cdnType === 'cloudflare') {
          return "https://".concat(MYWEBSITEBUILDER_BASE_URL, "/s/cdn/?").concat(encodeURIComponent(_this.src));
        } // skip our image server


        return _this.src;
      }

      var modifierStr = _this.modifiers.join('/');

      if (modifierStr !== '') {
        modifierStr += '/';
      }

      var baseUrl = '';

      if (_this.cdnType === 'cloudflare') {
        baseUrl = "https://".concat(MYWEBSITEBUILDER_BASE_URL);
      } else if (_this.cdnType === 'cloudflareHosted') {
        baseUrl = '';
      } else {
        // if (cdnType === 'impressly') {
        // Now everyone who uses imageproxy uses mywebsitebuilder, maybe this should have more options for store?
        // Maybe this should go to config file instead of here?
        baseUrl = "//image".concat(_this._proxyHash(_this.src) + 1, ".").concat(IMPRESSLY_BASE_URL);
      }

      return "".concat(baseUrl, "/s/cdn/").concat(modifierStr, "?").concat(encodeURIComponent(_this.src));
    };

    this.src = ImageProxyHelper.stripProxyUrl(src);
    var unsplashDomainIndex = src.indexOf(UNSPLASH_DOMAIN);
    this.useUnsplash = unsplashDomainIndex < 10 && unsplashDomainIndex >= 0;
    this.cdnType = cdnType;
    this.modifiers = [];
    return this;
  }

  (0, _createClass2["default"])(ImageProxyHelper, [{
    key: "calcCropRect",
    value: function calcCropRect(rect, size) {
      return [Math.round(rect.x * size.width), Math.round(rect.y * size.height), Math.round(rect.width * size.width), Math.round(rect.height * size.height)];
    }
  }, {
    key: "modifiyUnsplashUrl",
    value: function modifiyUnsplashUrl(url, width, height, cropRect) {
      if (!this.useUnsplash) {
        throw Error('no Unsplash image');
      }

      var params = (0, _urlHelper.getQueryParametersFromUrl)(url);

      if (width) {
        params.w = width;
      }

      if (height) {
        params.h = height;
      }

      if (cropRect) {
        params.rect = cropRect;
      }

      var split = url.split('?');
      return "".concat(split[0], "?").concat((0, _urlHelper.param)(params));
    }
  }], [{
    key: "getProxyUrl",

    /**
     * Will change the provided source URL and will return it prefixed with the Image Proxy Url.
     * @param {string} source, the image that should be routed through the image proxy.
     */
    value: function getProxyUrl(source) {
      return (0, _urlHelper.getUrl)(_urlHelper.siteNames.IMAGE_PROXY, source);
    }
  }, {
    key: "stripProxyUrl",
    value: function stripProxyUrl(src) {
      var splitUrl = src.split('?');

      if (splitUrl.length > 1) {
        var base = splitUrl[0];

        if (base.indexOf(MYWEBSITEBUILDER_BASE_URL) > -1 || base.indexOf(IMPRESSLY_BASE_URL) > -1) {
          // Return original url without resizing
          return splitUrl[1];
        }
      }

      return src;
    }
  }]);
  return ImageProxyHelper;
}();

var _default = ImageProxyHelper;
exports["default"] = _default;